const env = require("services/env");

/* class
 -------------------------------------------------- */

const {createElement, appendTo} = require("nevermorejs/lib/dom");

class FooterInformation {

	constructor(container) {
		container.on("itemMount", item => {
			this.setDefaultData(container, item);
			this.createItemDom(container, item);
			this.updateItem(container, item);
		});

		container.on("itemChange", item => {
			this.updateItem(container, item);
		});

		container.on("itemAdd", item => {
			this.updateItem(container, item);
		});
	}

	setDefaultData(container, item) {
		// Set default notify offset
		if (item.data.notify_offset == undefined) {
			const notificationOptions = env.get("options.scheduler.notificationOptions", []);
			item.data.notify_offset = notificationOptions[0];
		}
	}

	createItemDom(container, item) {
		const footer = item.dom.querySelector(".nvm-item-footer");

		// repeater
		appendTo(
			footer,
			createElement(`<div class="nvm-repeater-info"></div>`)
		);

		// notifications
		appendTo(
			footer,
			createElement(`<div class="nvm-notification-offset-info"></div>`)
		);
	}

	updateItem(container, item) {
		// repeater
		item.dom.querySelector(".nvm-repeater-info").innerHTML = item.repeats ?
			`Gentages hver ${item.from.format("ddd")}.` :
			``;

		item.dom.querySelector(".nvm-notification-offset-info")
			.innerHTML = `Påmindelse ${item.data.notify_offset} min.`;
	}

}

module.exports = FooterInformation;



// WEBPACK FOOTER //
// ./resources/js/components/backend/calendar/plugins/FooterInformation.js